export default __webpack_public_path__ + "static/media/Doodles.4cd277cf.png";